import { i18n } from "translate/i18n";

export const changePassword = i18n.t(
  "messages.authentication.changePassword"
);

export const informYourPassword = i18n.t(
  "messages.authentication.informYourPassword"
);
